import api from "../api";

export const GetVehicleModels = async (type: "BUS" | "TRUCK") => {
  const response = await api.get(`/v1/studies/vehicle-models?type=${type}`);

  return response.data;
};
